import * as browserUtils from '@tolk-ai/browser-utils';
import * as genericUtils from '@tolk-ai/generic-utils';

var CreateOneZendeskLoginConfigErrors;

(function (CreateOneZendeskLoginConfigErrors) {
  CreateOneZendeskLoginConfigErrors[CreateOneZendeskLoginConfigErrors["inexistingBot"] = 0] = "inexistingBot";
  CreateOneZendeskLoginConfigErrors[CreateOneZendeskLoginConfigErrors["emptySubdomain"] = 1] = "emptySubdomain";
})(CreateOneZendeskLoginConfigErrors || (CreateOneZendeskLoginConfigErrors = {}));

var GetOneZendeskLoginConfigConnectedErrors;

(function (GetOneZendeskLoginConfigConnectedErrors) {
  GetOneZendeskLoginConfigConnectedErrors[GetOneZendeskLoginConfigConnectedErrors["inexistingZendeskLoginConfigConnected"] = 0] = "inexistingZendeskLoginConfigConnected";
})(GetOneZendeskLoginConfigConnectedErrors || (GetOneZendeskLoginConfigConnectedErrors = {}));

var AuthenticateZendeskLoginErrors;

(function (AuthenticateZendeskLoginErrors) {
  AuthenticateZendeskLoginErrors[AuthenticateZendeskLoginErrors["invalidState"] = 0] = "invalidState";
  AuthenticateZendeskLoginErrors[AuthenticateZendeskLoginErrors["userAccessDenied"] = 1] = "userAccessDenied";
  AuthenticateZendeskLoginErrors[AuthenticateZendeskLoginErrors["inexistingAccessToken"] = 2] = "inexistingAccessToken";
})(AuthenticateZendeskLoginErrors || (AuthenticateZendeskLoginErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuthenticateZendeskLoginErrors () { return AuthenticateZendeskLoginErrors; },
  get CreateOneZendeskLoginConfigErrors () { return CreateOneZendeskLoginConfigErrors; },
  get GetOneZendeskLoginConfigConnectedErrors () { return GetOneZendeskLoginConfigConnectedErrors; }
});

const createOneZendeskLoginConfig$2 = authenticatedRequest => async (subDomain, botId, state) => {
  try {
    const result = await authenticatedRequest('post', `/v1/bots/${botId}/connectors-config/zendesk-login`, {
      botId,
      state,
      subDomain,
      url: ''
    });
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      if (error.response.data.error === 'emptySubdomain') {
        return CreateOneZendeskLoginConfigErrors.emptySubdomain;
      }

      if (error.response.data.error === 'inexistingBot') {
        return CreateOneZendeskLoginConfigErrors.inexistingBot;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneRestZendeskLoginConfigConnected = authenticatedRequest => async botId => {
  try {
    const result = await authenticatedRequest('get', `/v1/bots/${botId}/connectors-config/zendesk-login`);
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.data.error === 'inexistingZendeskLoginConfigConnected') {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestZendeskLoginConfigConnectedToZendeskLoginConfigConnected = restZendeskLoginConfigConnected => {
  return {
    accessToken: restZendeskLoginConfigConnected.accessToken,
    botId: restZendeskLoginConfigConnected.botId,
    state: restZendeskLoginConfigConnected.state,
    subDomain: restZendeskLoginConfigConnected.subDomain,
    url: restZendeskLoginConfigConnected.url
  };
};

const deleteOneZendeskLoginConfigConnected$3 = authenticatedRequest => async botId => {
  try {
    await authenticatedRequest('delete', `/v1/bots/${botId}/connectors-config/zendesk-login`);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const createOneZendeskLoginConfig$1 = authenticatedRequest => async (subDomain, botId, state) => {
  return createOneZendeskLoginConfig$2(authenticatedRequest)(subDomain, botId, state);
};

const getOneZendeskLoginConfigConnected$1 = authenticatedRequest => async botId => {
  const result = await getOneRestZendeskLoginConfigConnected(authenticatedRequest)(botId);

  if (result === null) {
    return GetOneZendeskLoginConfigConnectedErrors.inexistingZendeskLoginConfigConnected;
  }

  return convertRestZendeskLoginConfigConnectedToZendeskLoginConfigConnected(result);
};

const deleteOneZendeskLoginConfigConnected$2 = authenticatedRequest => async botId => {
  await deleteOneZendeskLoginConfigConnected$3(authenticatedRequest)(botId);
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOneZendeskLoginConfig: createOneZendeskLoginConfig$1,
  deleteOneZendeskLoginConfigConnected: deleteOneZendeskLoginConfigConnected$2,
  getOneZendeskLoginConfigConnected: getOneZendeskLoginConfigConnected$1
});

const getOneMongodbBot = mongodb => async botId => mongodb.collection('api_bots').findOne({
  bot_id: botId
});

const convertMongodbBotToBot = mongodbBot => ({
  id: mongodbBot.bot_id
});

const getOneBot = mongodb => async botId => {
  const result = await getOneMongodbBot(mongodb)(botId);

  if (result === null) {
    return null;
  }

  return convertMongodbBotToBot(result);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneBot: getOneBot
});

const convertPgZendeskLoginConfigToZendeskLoginConfig = pgZendeskLoginConfig => typeof pgZendeskLoginConfig.access_token === 'string' ? {
  accessToken: pgZendeskLoginConfig.access_token,
  botId: pgZendeskLoginConfig.bot_id,
  state: pgZendeskLoginConfig.state,
  subDomain: pgZendeskLoginConfig.sub_domain,
  url: pgZendeskLoginConfig.url
} : {
  botId: pgZendeskLoginConfig.bot_id,
  state: pgZendeskLoginConfig.state,
  subDomain: pgZendeskLoginConfig.sub_domain,
  url: pgZendeskLoginConfig.url
};

const getOnePgZendeskLoginConfigNotConnectedByState = pool => async state => (await pool.query(`SELECT bot_id, url, sub_domain, state
      FROM zendesk_config
      WHERE state=$1`, [state])).rows[genericUtils.ARRAY.FIRST_INDEX];

const getOnePgZendeskLoginConfigByBotId = pool => async botId => (await pool.query(`SELECT bot_id, url, sub_domain, state, access_token
      FROM zendesk_config
      WHERE bot_id=$1`, [botId])).rows[genericUtils.ARRAY.FIRST_INDEX];

const saveOnePgZendeskLoginConfig = pool => async zendeskLoginConfig => {
  await pool.query(`INSERT INTO
    zendesk_config(bot_id, sub_domain, url, state, access_token)
    VALUES($1, $2, $3, $4, $5)
    ON CONFLICT (bot_id) DO UPDATE
    SET bot_id=EXCLUDED.bot_id,
    sub_domain = $2,
    url = $3,
    state = $4,
    access_token = $5;
  `, [zendeskLoginConfig.botId, zendeskLoginConfig.subDomain, zendeskLoginConfig.url, zendeskLoginConfig.state, zendeskLoginConfig.accessToken]);
};

const deleteOnePgZendeskLoginConfigConnected = pool => async botId => {
  await pool.query(`DELETE FROM zendesk_config
    WHERE bot_id=$1
`, [botId]);
};

const saveOneZendeskLoginConfig = pool => async zendeskLoginConfig => {
  try {
    await saveOnePgZendeskLoginConfig(pool)(zendeskLoginConfig);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneZendeskLoginConfigNotConnectedByState = pool => async state => {
  try {
    const result = await getOnePgZendeskLoginConfigNotConnectedByState(pool)(state);

    if (!result) {
      return null;
    }

    return convertPgZendeskLoginConfigToZendeskLoginConfig(result);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneZendeskLoginConfigByBotId = pool => async botId => {
  try {
    const result = await getOnePgZendeskLoginConfigByBotId(pool)(botId);

    if (!result) {
      return null;
    }

    return convertPgZendeskLoginConfigToZendeskLoginConfig(result);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOneZendeskLoginConfigConnected$1 = pool => async botId => {
  try {
    await deleteOnePgZendeskLoginConfigConnected(pool)(botId);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteOneZendeskLoginConfigConnected: deleteOneZendeskLoginConfigConnected$1,
  getOneZendeskLoginConfigByBotId: getOneZendeskLoginConfigByBotId,
  getOneZendeskLoginConfigNotConnectedByState: getOneZendeskLoginConfigNotConnectedByState,
  saveOneZendeskLoginConfig: saveOneZendeskLoginConfig
});

const getOneRestZendeskLoginAccessToken = axios => async zendeskAccessTokenUrl => {
  try {
    return (await axios.post(zendeskAccessTokenUrl)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestZendeskLoginAccessTokenToZendeskLoginAccessToken = restZendeskLoginAccessToken => ({
  accessToken: restZendeskLoginAccessToken.access_token
});

const getAccessTokenUrl = (zendeskClientId, zendeskClientSecret, botManagementExpressRedirectUrl) => (authorizationCode, zendeskLoginConfig) => `https://${zendeskLoginConfig.subDomain}.zendesk.com/oauth/tokens?grant_type=authorization_code&code=${authorizationCode}&client_id=${zendeskClientId}&client_secret=${zendeskClientSecret}&redirect_uri=${encodeURIComponent(botManagementExpressRedirectUrl)}&scope=${encodeURIComponent('tickets:write users:read users:write')}`;

const getOneZendeskLoginAccessToken = (axios, zendeskClientId, zendeskClientSecret, botManagementReactBaseUrl) => async (authorizationCode, zendeskLoginConfig) => {
  const zendeskAccessTokenUrl = getAccessTokenUrl(zendeskClientId, zendeskClientSecret, botManagementReactBaseUrl)(authorizationCode, zendeskLoginConfig);
  const result = await getOneRestZendeskLoginAccessToken(axios)(zendeskAccessTokenUrl);

  if (!result) {
    return null;
  }

  return convertRestZendeskLoginAccessTokenToZendeskLoginAccessToken(result);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneZendeskLoginAccessToken: getOneZendeskLoginAccessToken
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestZendeskLoginConfigConnected: {
		type: "object",
		properties: {
			botId: {
				type: "string"
			},
			url: {
				type: "string"
			},
			subDomain: {
				type: "string"
			},
			state: {
				type: "string"
			},
			accessToken: {
				type: "string"
			}
		},
		required: [
			"botId",
			"url",
			"subDomain",
			"state",
			"accessToken"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	ZendeskLoginConfigState: {
		type: "string"
	},
	ZendeskLoginConfigSubdomain: {
		type: "string"
	},
	ZendeskLoginConfigUrl: {
		type: "string"
	},
	ZendeskLoginAccessToken: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			}
		},
		required: [
			"accessToken"
		],
		additionalProperties: false
	},
	ZendeskLoginConfigNotConnected: {
		type: "object",
		properties: {
			url: {
				$ref: "#/definitions/ZendeskLoginConfigUrl"
			},
			subDomain: {
				$ref: "#/definitions/ZendeskLoginConfigSubdomain"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			state: {
				$ref: "#/definitions/ZendeskLoginConfigState"
			}
		},
		required: [
			"url",
			"subDomain",
			"botId",
			"state"
		],
		additionalProperties: false
	},
	ZendeskLoginConfig: {
		type: "object",
		additionalProperties: false,
		properties: {
			accessToken: {
				type: "string"
			},
			url: {
				$ref: "#/definitions/ZendeskLoginConfigUrl"
			},
			subDomain: {
				$ref: "#/definitions/ZendeskLoginConfigSubdomain"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			state: {
				$ref: "#/definitions/ZendeskLoginConfigState"
			}
		},
		required: [
			"botId",
			"state",
			"subDomain",
			"url"
		]
	},
	ZendeskLoginConfigConnected: {
		type: "object",
		additionalProperties: false,
		properties: {
			accessToken: {
				type: "string"
			},
			url: {
				$ref: "#/definitions/ZendeskLoginConfigUrl"
			},
			subDomain: {
				$ref: "#/definitions/ZendeskLoginConfigSubdomain"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			state: {
				$ref: "#/definitions/ZendeskLoginConfigState"
			}
		},
		required: [
			"accessToken",
			"botId",
			"state",
			"subDomain",
			"url"
		]
	},
	MongoBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			}
		},
		required: [
			"bot_id"
		],
		additionalProperties: false
	},
	PgZendeskLoginConfigNotConnected: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			url: {
				type: "string"
			},
			sub_domain: {
				type: "string"
			},
			state: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"url",
			"sub_domain",
			"state"
		],
		additionalProperties: false
	},
	PgZendeskLoginConfig: {
		type: "object",
		additionalProperties: false,
		properties: {
			access_token: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			url: {
				type: "string"
			},
			sub_domain: {
				type: "string"
			},
			state: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"state",
			"sub_domain",
			"url"
		]
	},
	PgZendeskLoginConfigConnected: {
		type: "object",
		additionalProperties: false,
		properties: {
			access_token: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			url: {
				type: "string"
			},
			sub_domain: {
				type: "string"
			},
			state: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"bot_id",
			"state",
			"sub_domain",
			"url"
		]
	},
	RestBot: {
		type: "object",
		properties: {
			id: {
				type: "string"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	RestZendeskLoginConfig: {
		type: "object",
		properties: {
			botId: {
				type: "string"
			},
			url: {
				type: "string"
			},
			subDomain: {
				type: "string"
			},
			state: {
				type: "string"
			},
			accessToken: {
				type: "string"
			}
		},
		required: [
			"botId",
			"url",
			"subDomain",
			"state"
		],
		additionalProperties: false
	},
	RestZendeskLoginAccessToken: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			token_type: {
				type: "string",
				"const": "bearer"
			},
			scope: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"token_type",
			"scope"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const generateUrl = (subDomain, botManagementExpressRedirectUrl, zendeskSupportClientId, state) => `https://${subDomain}.zendesk.com/oauth/authorizations/new?response_type=code&redirect_uri=${encodeURIComponent(botManagementExpressRedirectUrl)}&client_id=${zendeskSupportClientId}&scope=${encodeURIComponent('tickets:write users:read users:write')}&state=${state}`;

const zendeskLoginConfigFactory = (botManagementExpressRedirectUrl, zendeskSupportClientId) => (subDomain, botId, state) => ({
  botId,
  state,
  subDomain,
  url: generateUrl(subDomain, botManagementExpressRedirectUrl, zendeskSupportClientId, state)
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  zendeskLoginConfigFactory: zendeskLoginConfigFactory
});

var infrastructurePorts = /*#__PURE__*/Object.freeze({
  __proto__: null
});

const isSubDomainEmpty = subDomain => subDomain.trim().length === genericUtils.ARRAY.EMPTY_LENGTH;

const createOneZendeskLoginConfig = (getOneBot, saveOneZendeskLoginConfig, zendeskLoginConfigFactory) => async (subDomain, botId, state) => {
  if (isSubDomainEmpty(subDomain)) {
    return CreateOneZendeskLoginConfigErrors.emptySubdomain;
  }

  const bot = await getOneBot(botId);

  if (!bot) {
    return CreateOneZendeskLoginConfigErrors.inexistingBot;
  }

  const zendeskLoginConfig = zendeskLoginConfigFactory(subDomain, botId, state);
  await saveOneZendeskLoginConfig(zendeskLoginConfig);
  return zendeskLoginConfig;
};

const getOneZendeskLoginConfigConnected = getOneZendeskLoginConfig => async botId => {
  const zendeskLoginConfig = await getOneZendeskLoginConfig(botId);

  if (!zendeskLoginConfig || typeof zendeskLoginConfig.accessToken !== 'string') {
    return GetOneZendeskLoginConfigConnectedErrors.inexistingZendeskLoginConfigConnected;
  }

  return Object.assign(Object.assign({}, zendeskLoginConfig), {
    accessToken: zendeskLoginConfig.accessToken
  });
};

const authenticateZendeskLogin = (getOneZendeskLoginConfigNotConnected, getOneZendeskLoginAccessToken, saveOneZendeskLoginConfig) => async (authorizationCode, state) => {
  const zendeskLoginConfig = await getOneZendeskLoginConfigNotConnected(state);

  if (!zendeskLoginConfig) {
    return AuthenticateZendeskLoginErrors.invalidState;
  }

  if (typeof authorizationCode === 'undefined') {
    return AuthenticateZendeskLoginErrors.userAccessDenied;
  }

  const zendeskLoginAccessToken = await getOneZendeskLoginAccessToken(authorizationCode, zendeskLoginConfig);

  if (!zendeskLoginAccessToken) {
    return AuthenticateZendeskLoginErrors.inexistingAccessToken;
  }

  const zendeskLoginConfigConnected = Object.assign(Object.assign({}, zendeskLoginConfig), {
    accessToken: zendeskLoginAccessToken.accessToken
  });
  return saveOneZendeskLoginConfig(zendeskLoginConfigConnected);
};

const deleteOneZendeskLoginConfigConnected = deleteOneZendeskLoginConfig => async botId => {
  await deleteOneZendeskLoginConfig(botId);
};

export { applicationPorts as appPorts, authenticateZendeskLogin, index$1 as axiosTokenService, index$4 as axiosZendesk, index as botModel, createOneZendeskLoginConfig, deleteOneZendeskLoginConfigConnected, entitiesSchemas$1 as entitiesSchemas, getOneZendeskLoginConfigConnected, infrastructurePorts as infraPorts, index$3 as mongodbBotsRepository, index$2 as postgresqlBotsRepository };
